import { FaArrowUp } from "react-icons/fa";

import { Container } from "./styles";

export function BackToTop({ isDesktop }) {
  return (
    <Container
      desktop={isDesktop}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      <FaArrowUp style={{ marginRight: ".6em" }} />
      back to top
    </Container>
  );
}
